import createApp from '@shopify/app-bridge';
import { app } from 'src/config';
import reportWebVitals from '../../reportWebVitals';

let host = null;
let SABAppInstance_Normal = null;
let SABAppInstance_NoForceRedirect = null;

export function saveHost(value) {
  host = value;
}

function createInstances() {
  const normalConfig = {
    apiKey: app.apiKey,
    host,
    forceRedirect: process.env.NODE_ENV !== 'development'
  };
  const configNoForceRedirect = {
    ...normalConfig,
    forceRedirect: false
  };
  SABAppInstance_Normal = createApp(normalConfig);
  SABAppInstance_NoForceRedirect = createApp(configNoForceRedirect);
}

export function getSABAppInstance_Normal() {
  if (!SABAppInstance_Normal) createInstances();
  reportWebVitals(SABAppInstance_Normal);
  return SABAppInstance_Normal;
}

export function getSABAppInstance_NoForceRedirect() {
  if (!SABAppInstance_NoForceRedirect) createInstances();
  reportWebVitals(SABAppInstance_NoForceRedirect);
  return SABAppInstance_NoForceRedirect;
}
